// extracted by mini-css-extract-plugin
module.exports = {"RedButton":"RedButton_RedButton__VDYoU"};